import { render, staticRenderFns } from "./fees.vue?vue&type=template&id=38d7f0e8&scoped=true&"
import script from "./fees.vue?vue&type=script&lang=js&"
export * from "./fees.vue?vue&type=script&lang=js&"
import style0 from "./fees.vue?vue&type=style&index=0&id=38d7f0e8&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d7f0e8",
  null
  
)

component.options.__file = "fees.vue"
export default component.exports